import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';

import Avatar from '@justgiving/avatar';

import { TimelineEntry } from '../../../../../types/__generated__';
import { useBasePageQuery } from '../../../../hooks';
import { makePhotoUrlFromAbsoluteUrl } from '../../../../utils/makePhotoUrl';
import { FormattedDate } from '../../../Formatters/FormattedDate';
import IsPageOwner from '../../../IsPageOwner/IsPageOwner';
import { Badge } from './Badge';
import { Menu, OnDeleteEntry } from './Menu';
import { OwnerName } from './OwnerName';

import timelineStyles from '../../Timeline.scss';
import timelineEntryStyles from '../../TimelineEntry/TimelineEntry.scss';

interface HeaderProps {
  timelineEntry: TimelineEntry;
  onDeleteEntry: OnDeleteEntry;
}

export const Header: FunctionComponent<HeaderProps> = ({
  timelineEntry,
  onDeleteEntry = () => {},
}) => {
  const { t } = useTranslation('common', { useSuspense: false });
  const { data } = useBasePageQuery();

  const owner = data?.page?.owner;

  return (
    <div className={timelineStyles.header}>
      <div
        className={timelineStyles.avatar}
        aria-hidden
        data-qa="timeline-entry-avatar"
      >
        <Avatar
          avatarSize="large"
          picture={makePhotoUrlFromAbsoluteUrl(owner?.avatar)}
        />
        <Badge publishingSource={timelineEntry.publishingSource} />
      </div>
      <div className="jg-display-flex jg-flex-g1 jg-flex-aic">
        <div className="jg-flex-g1">
          <OwnerName
            publishingSource={timelineEntry.publishingSource}
            name={owner?.name}
          />
          <p className={timelineEntryStyles.subtitle}>
            {timelineEntry.createdAt && (
              <FormattedDate value={timelineEntry.createdAt} />
            )}
          </p>
        </div>
        <IsPageOwner>
          <Menu onDeleteEntry={onDeleteEntry} timelineEntry={timelineEntry} />
        </IsPageOwner>
      </div>
    </div>
  );
};

Header.displayName = 'TimelineEntryHeader';
